// extracted by mini-css-extract-plugin
module.exports = {"AppStyle":"App_AppStyle__fMDA6"};